(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-volleyball/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/themes/sport-volleyball/assets/javascripts/init.js'); "use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

(function (svs) {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_volleyball = svs.themes.sport_volleyball || {};

  svs.themes.sport_volleyball.init = function (func, params) {
    var log = new svs.core.log.Logger('svs.themes.sport_volleyball.init');

    if (!_.isArray(params)) {
      params = [params];
    }

    if (typeof svs.themes.sport_volleyball[func] === 'function') {
      var _svs$themes$sport_vol;

      return (_svs$themes$sport_vol = svs.themes.sport_volleyball)[func].apply(_svs$themes$sport_vol, _toConsumableArray(params));
    }

    log.debug("function ".concat(func, " does not exist in this theme"));
  };
})(svs);
 })(window);